import { render, staticRenderFns } from "./answerTags.vue?vue&type=template&id=67a7b606&scoped=true&"
import script from "./answerTags.vue?vue&type=script&lang=ts&"
export * from "./answerTags.vue?vue&type=script&lang=ts&"
import style0 from "./answerTags.vue?vue&type=style&index=0&id=67a7b606&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7b606",
  null
  
)

export default component.exports